import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import ReactApexChart from "react-apexcharts"
import { store } from 'store/index'

import { TOGGLE_LEFT_MENU } from 'store/layout/actions'
import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import { httpOk, GET } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

function Index({ shift_id }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [data, setData] = useState({})
	const [showComponent, setShowComponent] = useState({
		'main': false,
		'chartSales': false,
		'orderTypesType': 'table',
		'menusType': 'table',
		'productsType': 'table',
		'paymentsType': 'table',
		'expensesType': 'table',
		'cashiersType': 'table',
		'waitersType': 'table',
	})
	const [chartSales, setChartSales] = useState({
		series: [
			{
				name: t('sales'),
				data: [],
				yAxis: 0
			},
			{
				name: t('cheques'),
				data: [],
				yAxis: 1
			}
		],
		options: {
			colors: ['#34c38f', '#f1b44c'],
			chart: {
				height: 350,
				type: 'line',
				toolbar: {
					show: false
				},
				background: '#fff',
			},
			legend: {
				show: false
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			markers: {
				size: 5,
				colors: undefined,
				strokeWidth: 0,
				shape: "circle",
			},
			yaxis: [
				{
					title: { text: t('sales') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				},
				{
					opposite: true,
					title: { text: t('cheques') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				}
			],
			xaxis: {
				tooltip: {
					enabled: false
				},
				categories: []
			},
			tooltip: {
			},
		},
	})
	const [chartOrderSubTypes, setChartOrderSubTypes] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	})
	const [chartMenus, setChartMenus] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	})
	const [chartProducts, setChartProducts] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	})
	const [chartExpenses, setChartExpenses] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	})
	const [chartPaymentTypes, setChartPaymentTypes] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	})
	const [chartCashiers, setChartCashiers] = useState({
		series: [{
			name: t('sales_amount'),
			data: []
		}],
		options: {
			chart: {
				type: 'bar',
				height: 350
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					borderRadiusApplication: 'end',
					horizontal: true,
				}
			},
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: [],
			}
		},
	})
	const [chartWaiters, setChartWaiters] = useState({
		series: [{
			name: t('sales_amount'),
			data: []
		}],
		options: {
			chart: {
				type: 'bar',
				height: 350
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					borderRadiusApplication: 'end',
					horizontal: true,
				}
			},
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: [],
			}
		},
	})
	
	async function getData() {
		store.dispatch(SHOW_LOADER());

		var chartSalesCopy = { ...chartSales }
		var chartOrderSubTypesCopy = { ...chartOrderSubTypes }
		var chartMenusCopy = { ...chartMenus }
		var chartProductsCopy = { ...chartProducts }
		var chartExpensesCopy = { ...chartExpenses }
		var chartPaymentTypesCopy = { ...chartPaymentTypes }
		var chartCashiersCopy = { ...chartCashiers }
		var chartWaitersCopy = { ...chartWaiters }

		const response = await GET(`/report-dashboard-z?shift_id=${shift_id}`)
		if (httpOk(response)) {
			setData(response.data)

			chartSalesCopy.series[0]['data'] = response.data.chart_sales['series_sales']
			chartSalesCopy.series[1]['data'] = response.data.chart_sales['series_cheqeus']
			chartSalesCopy.options.xaxis.categories = response.data.chart_sales['series_hours']

			chartOrderSubTypesCopy.series = response.data.chart_order_sub_types['series']
			chartOrderSubTypesCopy.options.labels = response.data.chart_order_sub_types['labels']

			chartMenusCopy.series = response.data.chart_menus['series']
			chartMenusCopy.options.labels = response.data.chart_menus['labels']

			chartProductsCopy.series = response.data.chart_products['series']
			chartProductsCopy.options.labels = response.data.chart_products['labels']

			chartExpensesCopy.series = response.data.chart_expenses['series']
			chartExpensesCopy.options.labels = response.data.chart_expenses['labels']

			chartPaymentTypesCopy.series = response.data.chart_payment_types['series']
			chartPaymentTypesCopy.options.labels = response.data.chart_payment_types['labels']

			chartCashiersCopy.series[0]['data'] = response.data.chart_cashiers['series']
			chartCashiersCopy.options.xaxis.categories = response.data.chart_cashiers['categories']

			chartWaitersCopy.series[0]['data'] = response.data.chart_waiters['series']
			chartWaitersCopy.options.xaxis.categories = response.data.chart_waiters['categories']

			setShowComponent({
				...showComponent,
				'main': true,
				'chartSales': true,
			})
			setChartSales(chartSalesCopy)
			setChartOrderSubTypes(chartOrderSubTypesCopy)
			setChartMenus(chartMenusCopy)
			setChartProducts(chartProductsCopy)
			setChartExpenses(chartExpensesCopy)
			setChartPaymentTypes(chartPaymentTypesCopy)
			setChartCashiers(chartCashiersCopy)
			setChartWaiters(chartWaitersCopy)
		}

		store.dispatch(HIDE_LOADER());
	}

	useEffect(() => {
		getData()
		dispatch(TOGGLE_LEFT_MENU(false))
	}, [shift_id]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{showComponent.main &&
				<>
					{/* <button onClick={() => getData()}>button</button> */}
					<div className="d-flex align-items-center gap-3 mb-3">
						<div className="w-100">
							<div className="card w-100 h-100">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="mb-2">{t('sales_amount')}</h6>
									</div>
									<div className="d-flex w-75 text-nowrap">
										<h4>{formatMoney(data.total_sales)}</h4>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100">
							<div className="card w-100 h-100">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="mb-2">{t('sales')}</h6>
									</div>
									<div className="d-flex w-75 text-nowrap">
										<h4>{formatMoney(data.sales)}</h4>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100">
							<div className="card w-100 h-100">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="mb-2">{t('allowances')}</h6>
									</div>
									<div className="d-flex w-75 text-nowrap">
										<h4>{formatMoney(data.allowances)}</h4>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100">
							<div className="card w-100 h-100">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="mb-2">{t('discounts')}</h6>
									</div>
									<div className="d-flex w-75 text-nowrap">
										<h4>{formatMoney(data.discount)}</h4>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100">
							<div className="card w-100 h-100">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="mb-2">{t('products')}</h6>
									</div>
									<div className="d-flex w-75 text-nowrap">
										<h4>{formatMoney(data.count_products)}</h4>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="d-flex align-items-center gap-3 mb-3">
						<div className="w-100" style={{ 'height': '70px' }}>
							<div className="card h-100 bg-primary-gradient">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="text-white">{t('cheques')}</h6>
									</div>
									<div className="text-white">
										<b>{formatMoney(data.count_cheques)}</b>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100" style={{ 'height': '70px' }}>
							<div className="card h-100 bg-warning-gradient">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="text-white">{t('average_check')}</h6>
									</div>
									<div className="text-white">
										<b>{formatMoney(data.average_cheque)}</b>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100" style={{ 'height': '70px' }}>
							<div className="card h-100 bg-warning-gradient">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="text-white">{t('average_cheque_depth')}</h6>
									</div>
									<div className="text-white">
										<b>{formatMoney(data.average_cheque_depth, 2)}</b>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100" style={{ 'height': '70px' }}>
							<div className="card h-100 bg-success-gradient">
								<div className="px-3 pt-3 pb-2 pt-0">
									<div className="d-flex justify-content-between">
										<h6 className="text-white">{t('guests')}</h6>
									</div>
									<div className="text-white">
										<b>{formatMoney(data.count_guests)}</b>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100" style={{ 'height': '70px' }}>
							<div className="card h-100 bg-danger-gradient">
								<div className="h-100 px-3 pt-3 pb-2 pt-0">
									<div className="h-100 d-flex flex-column justify-content-center">
										<h6 className="text-nowrap text-white">
											<b>{t('number_of_checks')} [ {t('deleted')} ]: {formatMoney(data.count_deleted_cheques)}</b>
										</h6>
										<h6 className="text-nowrap text-white">
											<b>{t('number_of_products')} [ {t('deleted')} ]: {formatMoney(data.count_deleted_products)}</b>
										</h6>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* PAYMENT TYPES */}
					<div className="row mb-3">
						<div className="col-md-2">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<div className="d-flex flex-column justify-content-center align-items-center h-100">
										<div className="d-flex flex-column gap-3">
											<div>
												<h3 className="text-success">{t('cash')}</h3>
												<h2>{formatMoney(data.cash)}</h2>
											</div>
											<div>
												<h3 className="text-warning">{t('terminal')}</h3>
												<h2>{formatMoney(data.terminal)}</h2>
											</div>
											<div>
												<h3 className="text-primary">{t('amount')}</h3>
												<h2>{formatMoney(data.total_money)}</h2>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-5">
							<div className="card" style={{ 'height': '450px', 'border': '1px solid #34c38f' }}>
								<div className="card-body">
									<h5>{t('payment_types')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.productsType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'productsType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.productsType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'productsType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.productsType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('name2')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.payment_types?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="pie"
											height={350}
											series={chartPaymentTypes.series}
											options={chartPaymentTypes.options}
										/>
									}
								</div>
							</div>
						</div>
						<div className="col-md-5">
							<div className="card" style={{ 'height': '450px', 'border': '1px solid #f46a6a' }}>
								<div className="card-body">
									<h5>{t('expenses')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.expensesType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'expensesType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.expensesType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'expensesType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.expensesType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('name2')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.expenses?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="pie"
											height={350}
											series={chartExpenses.series}
											options={chartExpenses.options}
										/>
									}
								</div>
							</div>
						</div>
					</div>
					{/* PAYMENT TYPES */}

					<div className="row mb-3">
						<div className="col-md-4">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<h5>{t('order_types')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.orderTypesType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'orderTypesType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.orderTypesType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'orderTypesType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.orderTypesType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('name2')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.order_sub_types?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="pie"
											height={350}
											series={chartOrderSubTypes.series}
											options={chartOrderSubTypes.options}
										/>
									}
								</div>
							</div>
						</div>
						<div className="col-md-8">
							<div className="card">
								<div className="card-body">
									<div className="d-flex">
										<div className="d-flex align-items-center flex-wrap">
											<div className="chart-header-title">
													{t('sales')} & {t('cheques')}
											</div>
										</div>
									</div>
									<ReactApexChart
										type="line"
										height={375}
										series={chartSales.series}
										options={chartSales.options}
									/>
								</div>
							</div>
						</div>
					</div>


					<div className="row mb-3">
						<div className="col-md-6">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<h5>{t('menu')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.menusType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'menusType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.menusType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'menusType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.menusType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('name2')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.menus?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="pie"
											height={350}
											series={chartMenus.series}
											options={chartMenus.options}
										/>
									}
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<h5>{t('products')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.productsType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'productsType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.productsType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'productsType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.productsType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('name2')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('quantity')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.products?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="pie"
											height={350}
											series={chartProducts.series}
											options={chartProducts.options}
										/>
									}
								</div>
							</div>
						</div>
					</div>

					{/* CASHIER WAITERS */}
					<div className="row mb-3">
						<div className="col-md-4">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<h5>{t('cashiers')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.cashiersType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'cashiersType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.cashiersType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'cashiersType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.cashiersType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('employee')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('cheques')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.cashiers?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.total_quantity)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="bar"
											height={350}
											series={chartCashiers.series}
											options={chartCashiers.options}
										/>
									}
								</div>
							</div>
						</div>
						<div className="col-md-8">
							<div className="card" style={{ 'height': '450px' }}>
								<div className="card-body">
									<h5>{t('waiters')}</h5>
									<div className="dashboard-icons d-flex mt-2">
										<div className={"tab " + (showComponent.waitersType === 'table' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'waitersType': 'table' })}>
											<i className="uil uil-list-ul"></i>
										</div>
										<div className={"tab " + (showComponent.waitersType === 'chart' ? 'active' : '')}
											onClick={() => setShowComponent({ ...showComponent, 'waitersType': 'chart' })}>
											<i className="uil uil-chart-pie-alt"></i>
										</div>
									</div>
									{showComponent.waitersType === 'table' ?
										<div className="table-responsive table-fixed mt-3" style={{ 'height': '340px', 'overflow': 'auto' }}>
											<table className="table table-bordered table-hover mb-0">
												<thead>
													<tr>
														<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
														<th style={{ 'width': '100%' }}>{t('employee')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('guests')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('cheques')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('sales')}</th>
														<th style={{ 'minWidth': '100px' }} className="text-end">{t('allowances')}</th>
														<th style={{ 'minWidth': '150px' }} className="text-end">{t('sales_amount')}</th>
														<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
													</tr>
												</thead>
												<tbody>
													{data?.waiters?.map((item, index) => (
														<tr key={index}>
															<td className="text-center">{index + 1}</td>
															<td className="td-ellipsis" title={item.name}>
																{item.name}
															</td>
															<td className="text-end">{formatMoney(item.count_guests)}</td>
															<td className="text-end">{formatMoney(item.count_cheques)}</td>
															<td className="text-end">{formatMoney(item.total_amount)}</td>
															<td className="text-end">{formatMoney(item.total_allowances)}</td>
															<td className="text-end">{formatMoney(item.total_amount_service)}</td>
															<td className="text-end">{formatMoney(item.percentage, 2)}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
										:
										<ReactApexChart
											type="bar"
											height={350}
											series={chartWaiters.series}
											options={chartWaiters.options}
										/>
									}
								</div>
							</div>
						</div>
					</div>
					{/* CASHIER WAITERS */}
				</>
			}
		</>
	)
}

export default Index